export const COLS = 28;
export const ROWS = 31;
// --- movement (tiles/sec) ---
export const PAC_SPEED = 6.0;
export const GHOST_SPEED = 5.7;
export const GHOST_FRIGHT = 3.6;
export const GHOST_EATEN = 9.5;
export const GHOST_TUNNEL_MULT = 0.5; // ghosts move at HALF speed in the tunnel row
export const PAC_SPEED_BOOST_MULT = 1.4; // Speed power-up
export const CORNER_CUT_TOLERANCE = 0.1;
export const CLYDE_FLEE_DIST2 = 64; // 8 tiles squared
export const SCATTER_CHASE = [
    { duration: 7, mode: 'scatter' },
    { duration: 20, mode: 'chase' },
    { duration: 7, mode: 'scatter' },
    { duration: 20, mode: 'chase' },
    { duration: 5, mode: 'scatter' },
    { duration: 20, mode: 'chase' },
    { duration: 5, mode: 'scatter' },
    { duration: -1, mode: 'chase' },
];
export const FRIGHT_BASE = 6.0;
export const FRIGHT_MIN = 2.0;
export const FRIGHT_FLASH_WINDOW = 2.0; // last 2s of fright, ghosts flash (render-only)
export const POWERUP_NO_SPAWN_EARLY = 10.0;
export const POWERUP_INTERVAL_LO = 12.0;
export const POWERUP_INTERVAL_HI = 22.0;
export const POWERUP_PICKUP_LIFETIME = 9.0;
export const HEART_PICKUP_LIFETIME = 12.0;
export const HEART_SPAWN_DOT_RATIO = 0.6;
export const RESPAWN_INVULN_T = 1.2;
// --- scoring ---
export const SCORE_PELLET = 10;
export const SCORE_ENERGIZER = 50;
export const SCORE_GHOSTS = [200, 400, 800, 1600];
export const FRUIT_TIERS = [
    100, 300, 500, 700, 1000, 2000, 3000, 5000,
];
/** PRD fruit bands: L1=Cherry, L2=Strawberry, L3-4=Orange, L5-6=Apple,
 * L7-8=Melon, L9-10=Galaxian, L11-12=Bell, L13+=Key. */
export function fruitTierIndex(level) {
    if (level <= 1)
        return 0;
    if (level === 2)
        return 1;
    const idx = 2 + Math.floor((level - 3) / 2);
    return idx > 7 ? 7 : idx;
}
export function fruitValue(level) {
    return FRUIT_TIERS[fruitTierIndex(level)];
}
export const EXTRA_LIFE_FIRST = 10000;
// --- lives ---
export const DEFAULT_LIVES = 3;
export const LIVES_CAP = 5;
// --- co-op ---
export const COOP_TARGET_REEVAL_T = 1.0;
// --- classic dot-triggered fruit (SPEC.md §1.2 scoring paragraph) ---
export const FRUIT_DOT_THRESHOLD_1 = 70;
export const FRUIT_DOT_THRESHOLD_2 = 170;
export const FRUIT_LIFETIME = 10.0;
export const FRUIT_PICKUP_RADIUS = 0.6;
export const POWERUP_PICKUP_RADIUS = 0.6;
export const GHOST_COLLIDE_RADIUS = 0.7;
export const RESCUE_PING_RADIUS2 = 1.0;
// --- power-ups ---
export function powerupDuration(p) {
    switch (p) {
        case 'speed':
            return 8.0;
        case 'magnet':
            return 5.0;
        case 'freeze':
            return 4.0;
        case 'phase':
            return 5.0;
        case 'scorex2':
            return 10.0;
        default:
            return 0.0; // cherry, heart apply instantly, no timed duration
    }
}
/** Timed power-ups whose DURATION applies to the WHOLE team, not just the
 * picker (freeze/scorex2). Cherry is ALSO team-wide per SPEC.md §1.2, but it
 * has no timed duration -- it's an instant score bonus -- so its team-wide
 * payout is handled by a dedicated branch in applyPickup() rather than by
 * this predicate. */
export function isGlobalPowerup(p) {
    return p === 'freeze' || p === 'scorex2';
}
// weighted random pool for the seeded power-up spawner (Heart is excluded —
// it spawns deterministically at the 60%-pellets-eaten milestone instead).
export const POWERUP_WEIGHTS = [
    ['cherry', 6],
    ['speed', 4],
    ['magnet', 4],
    ['freeze', 2],
    ['phase', 2],
    ['scorex2', 2],
];
export const GHOST_ORDER = [
    'blinky',
    'pinky',
    'inky',
    'clyde',
];
export const GHOST_HOUSE_DELAY = {
    blinky: 0.0,
    pinky: 2.0,
    inky: 5.0,
    clyde: 9.0,
};
export const SCATTER_CORNERS = {
    blinky: { x: COLS - 3, y: 0 },
    pinky: { x: 2, y: 0 },
    inky: { x: COLS - 1, y: ROWS - 1 },
    clyde: { x: 0, y: ROWS - 1 },
};
//# sourceMappingURL=constants.js.map